import React from "react"
import { TextField, Dialog, FlatButton, Toggle } from "material-ui"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import EmployeeChip from "../../components/employee/EmployeeChip"
import AuthenticationStore from "../../stores/AuthenticationStore"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
import ChooseHierarchyJobChip from "../../components/hierarchy/choose_hierarchy/ChooseHierarchyJobChip"
import JobsChip from "../../components/job/JobsChip"
import * as api from "../../api"
import { IDeviceDocument, EAddDeviceValidationType, IUIUser, IJobDocument } from "../../models"
import AppStateStore from "../../stores/AppStateStore"
import AccountStore from "../../stores/AccountStore"
import { red500 } from "material-ui/styles/colors"
import { checkJobFieldAvailable } from "../../helpers/jobHelper"
import * as jobHelper from "../../helpers/jobHelper"
import IVRNumberText from "../common/IVRChipList/IVRNumberText"

const activationCodeRegExp = /^[a-zA-Z0-9-]*$/
interface IProps {
	editableDevice: IDeviceDocument
	handleClose(): void
	handleAdd(device: IDeviceDocument): Promise<EAddDeviceValidationType>
	handleUpdate(device: IDeviceDocument): Promise<void>

	//hierarchy -> device page
	isHierarchyDevice?: boolean
	//job -> device page
	isJobDevice?: boolean
	// employee detail -> device tab
	employeeForIndividual?: IUIUser
	// BioLoc exception -> device info	
	readonly?: boolean
}
interface IState {
	name: string
	activationCode: string
	nameErrorText: string
	activationCodeErrorText: string
	saveClicked: boolean
	disableException: boolean
	enableLocationFraudPrevention: boolean
	isClockMode: boolean
	isMobileClockMode: boolean
	employeeForIndividual: IUIUser,
	errEmployeeForIndividual: boolean
	hierarchyItemId: string
	jobId: string
	errorHierarchyLevel: string
	errorJob: string
	adminPin: string
	externalId: string
	limitJobs: boolean
	availableJobs: IJobDocument[]
	wariningAccountLevelClockMode: boolean
	errorAccountLevelClockModeMaxJobLimit: boolean
	activeJobCount: number
	description: string
	field1: string
	field2: string
	field3: string
	field4: string
	enableIVR: boolean
	approvedIVRPhoneNumber: string
	errorApprovedIVRPhoneNumber: boolean
}

export default class AddDeviceDialog extends React.Component<IProps, IState> {
	private isHierarchyJobDevice: boolean
	constructor(props: IProps) {
		super(props)
		const editableDevice = props.editableDevice
		this.isHierarchyJobDevice = props.isHierarchyDevice || props.isJobDevice
		const enableIVR = editableDevice && editableDevice.ApprovedIVRPhoneNumbers && editableDevice.ApprovedIVRPhoneNumbers.length > 0
		const approvedIVRPhoneNumber = enableIVR ?
			editableDevice.ApprovedIVRPhoneNumbers[0]
			: null
		this.state = {
			name: editableDevice ? editableDevice.Name : "",
			activationCode: editableDevice ? editableDevice.RegistrationCode : "",
			nameErrorText: "",
			activationCodeErrorText: "",
			saveClicked: false,
			disableException: editableDevice ? editableDevice.DisableLocationException : false,
			enableLocationFraudPrevention: editableDevice ? editableDevice.EnableLocationFraudPrevention : false,
			isClockMode:
				props.employeeForIndividual ?
					false :
					this.isHierarchyJobDevice ?
						true :
						!editableDevice || (editableDevice && editableDevice.UserId) ?
							false :
							true,
			isMobileClockMode: editableDevice ? editableDevice.IsMobileClock : false,
			employeeForIndividual: props.employeeForIndividual,
			errEmployeeForIndividual: false,
			hierarchyItemId: editableDevice ? editableDevice.HierarchyItemId : HierarchySettingsStore.getGlobalLevelItemFilterId() ? HierarchySettingsStore.getGlobalLevelItemFilterId() : null,
			jobId: editableDevice ? editableDevice.JobId : null,
			errorHierarchyLevel: "",
			errorJob: "",
			adminPin: editableDevice && editableDevice.AdminPin ? editableDevice.AdminPin : "",
			externalId: editableDevice && editableDevice.ExternalId ? editableDevice.ExternalId : "",
			limitJobs: editableDevice && editableDevice.AvailableJobIds && editableDevice.AvailableJobIds.length > 0,
			availableJobs: [],
			wariningAccountLevelClockMode: false,
			errorAccountLevelClockModeMaxJobLimit: false,
			activeJobCount: null,
			description: editableDevice && editableDevice.Description ? editableDevice.Description : "",
			field1: editableDevice && editableDevice.Field1 ? editableDevice.Field1 : "",
			field2: editableDevice && editableDevice.Field2 ? editableDevice.Field2 : "",
			field3: editableDevice && editableDevice.Field3 ? editableDevice.Field3 : "",
			field4: editableDevice && editableDevice.Field4 ? editableDevice.Field4 : "",
			enableIVR: editableDevice && editableDevice.ApprovedIVRPhoneNumbers && editableDevice.ApprovedIVRPhoneNumbers.length > 0,
			approvedIVRPhoneNumber: approvedIVRPhoneNumber,
			errorApprovedIVRPhoneNumber: enableIVR && !approvedIVRPhoneNumber ? true : false
		}
		autobind(this)
	}

	componentDidMount() {
		!this.props.employeeForIndividual && this.props.editableDevice && this.props.editableDevice.UserId &&
			api.getUIUser(this.props.editableDevice.UserId).then(res =>
				this.setState({ employeeForIndividual: res.data })
			)
		this.props.editableDevice && this.props.editableDevice.AvailableJobIds && this.props.editableDevice.AvailableJobIds.length &&
			api.getJobsByIds(this.props.editableDevice.AvailableJobIds).then(res =>
				this.setState({ availableJobs: res.data })
			)
		AccountStore.getJobsEnabled() &&
			api.getActiveJobCount().then(res =>
				this.setState({ activeJobCount: res.data })
			)
	}

	clearState() {
		this.setState({
			name: "",
			activationCode: "",
			nameErrorText: "",
			activationCodeErrorText: "",
			saveClicked: false,
			employeeForIndividual: null,
			errEmployeeForIndividual: false,
			isClockMode: false,
			isMobileClockMode: false,
			adminPin: "",
			externalId: "",
			limitJobs: false,
			availableJobs: [],
			wariningAccountLevelClockMode: false,
			errorAccountLevelClockModeMaxJobLimit: false,
			description: "",
			field1: "",
			field2: "",
			field3: "",
			field4: "",
			enableIVR: false,
			approvedIVRPhoneNumber: null,
			errorApprovedIVRPhoneNumber: false,
		})
	}

	handleRequestSave() {
		this.setState({ saveClicked: true }, () => {
			if (this.validateForm()) {
				this.props.editableDevice ? this.updateDevice() : this.addDevice()
			}
		})
	}

	updateDevice() {
		this.props.handleUpdate({
			Id: this.props.editableDevice.Id,
			Name: this.state.name.trim(),
			RegistrationCode: this.state.activationCode,
			DisableLocationException: this.state.disableException,
			EnableLocationFraudPrevention: (!this.state.isClockMode || this.state.isMobileClockMode) && this.state.enableLocationFraudPrevention,
			AccountId: AuthenticationStore.getCookieAccountId(),
			HierarchyItemId: this.state.employeeForIndividual ? this.state.employeeForIndividual.DefaultHierarchyItemId : this.state.hierarchyItemId,
			JobId: (this.state.isClockMode && !this.state.isMobileClockMode) ? this.state.jobId : null,
			UserId: this.state.isClockMode ? null : this.state.employeeForIndividual.Id,
			IsMobileClock: this.state.isMobileClockMode,
			AdminPin: (this.state.isClockMode || this.state.isMobileClockMode) && this.state.adminPin.trim() ? this.state.adminPin.trim() : null,
			ExternalId: (this.state.isClockMode || this.state.isMobileClockMode) && this.state.externalId ? this.state.externalId : null,
			AvailableJobIds: this.checkAvailableJob() ? this.state.availableJobs.map(i => i.Id) : [],
			Description: this.state.description ? this.state.description.trim() : null,
			Field1: this.state.field1 ? this.state.field1.trim() : null,
			Field2: this.state.field2 ? this.state.field2.trim() : null,
			Field3: this.state.field3 ? this.state.field3.trim() : null,
			Field4: this.state.field4 ? this.state.field4.trim() : null,
			ApprovedIVRPhoneNumbers: this.checkIVRNumberAvailable() && this.state.enableIVR && this.state.approvedIVRPhoneNumber ?
				[this.state.approvedIVRPhoneNumber] :
				[],
		})
			.then(() => this.props.handleClose())
			.catch(() => this.setState({ activationCodeErrorText: strings.Failed_to_update_device }))
	}

	addDevice() {
		const { isClockMode, isMobileClockMode, employeeForIndividual } = this.state
		this.props.handleAdd({
			Name: this.state.name.trim(),
			RegistrationCode: this.state.activationCode,
			DisableLocationException: this.state.disableException,
			EnableLocationFraudPrevention: (!this.state.isClockMode || this.state.isMobileClockMode) && this.state.enableLocationFraudPrevention,
			AccountId: AuthenticationStore.getCookieAccountId(),
			HierarchyItemId: employeeForIndividual ? employeeForIndividual.DefaultHierarchyItemId : this.state.hierarchyItemId,
			JobId: (isClockMode && !this.state.isMobileClockMode) ? this.state.jobId : null,
			UserId: isClockMode ? null : employeeForIndividual.Id,
			IsMobileClock: isMobileClockMode,
			AdminPin: (this.state.isClockMode || this.state.isMobileClockMode) && this.state.adminPin.trim() ? this.state.adminPin.trim() : null,
			ExternalId: (this.state.isClockMode || this.state.isMobileClockMode) && this.state.externalId ? this.state.externalId : null,
			AvailableJobIds: this.checkAvailableJob() ? this.state.availableJobs.map(i => i.Id) : [],
			Description: this.state.description ? this.state.description.trim() : null,
			Field1: this.state.field1 ? this.state.field1.trim() : null,
			Field2: this.state.field2 ? this.state.field2.trim() : null,
			Field3: this.state.field3 ? this.state.field3.trim() : null,
			Field4: this.state.field4 ? this.state.field4.trim() : null,
			ApprovedIVRPhoneNumbers: this.checkIVRNumberAvailable() && this.state.enableIVR && this.state.approvedIVRPhoneNumber ?
				[this.state.approvedIVRPhoneNumber] :
				[],
		})
			.then(res => {
				switch (res) {
					case EAddDeviceValidationType.Valid:
						this.props.handleClose()
						break
					case EAddDeviceValidationType.InvalidRegistrationCode:
						this.setState({ activationCodeErrorText: strings.Registration_code_could_not_be_found })
						break
					case EAddDeviceValidationType.AlreadyUsedRegistrationCode:
						this.setState({ activationCodeErrorText: strings.Registration_code_used_already })
						break
					case EAddDeviceValidationType.ApprovedIVRPhoneHasNotJob:
						this.setState({ errorJob: strings.select_a_job })
						break
				}
			})
	}

	handleRequestClose() {
		this.clearState()
		this.props.handleClose()
	}

	handleRequestAddAnother() {
		const { isClockMode, isMobileClockMode, employeeForIndividual } = this.state
		this.setState({ saveClicked: true }, () => {
			if (this.validateForm()) {
				this.props.handleAdd({
					Name: this.state.name.trim(),
					RegistrationCode: this.state.activationCode,
					DisableLocationException: this.state.disableException,
					EnableLocationFraudPrevention: (!this.state.isClockMode || this.state.isMobileClockMode) && this.state.enableLocationFraudPrevention,
					AccountId: AuthenticationStore.getCookieAccountId(),
					HierarchyItemId: employeeForIndividual ? employeeForIndividual.DefaultHierarchyItemId : this.state.hierarchyItemId,
					JobId: (isClockMode && !this.state.isMobileClockMode) ? this.state.jobId : null,
					UserId: isClockMode ? null : employeeForIndividual.Id,
					IsMobileClock: isMobileClockMode,
					AdminPin: (this.state.isClockMode || this.state.isMobileClockMode) && this.state.adminPin.trim() ? this.state.adminPin.trim() : null,
					ExternalId: (this.state.isClockMode || this.state.isMobileClockMode) && this.state.externalId ? this.state.externalId : null,
					AvailableJobIds: this.checkAvailableJob() ? this.state.availableJobs.map(i => i.Id) : [],
					Description: this.state.description ? this.state.description.trim() : null,
					Field1: this.state.field1 ? this.state.field1.trim() : null,
					Field2: this.state.field2 ? this.state.field2.trim() : null,
					Field3: this.state.field3 ? this.state.field3.trim() : null,
					Field4: this.state.field4 ? this.state.field4.trim() : null,
					ApprovedIVRPhoneNumbers: this.checkIVRNumberAvailable() && this.state.enableIVR && this.state.approvedIVRPhoneNumber ?
						[this.state.approvedIVRPhoneNumber] :
						[],
				})
					.then(res => {
						switch (res) {
							case EAddDeviceValidationType.Valid:
								this.clearState()
								break
							case EAddDeviceValidationType.InvalidRegistrationCode:
								this.setState({ activationCodeErrorText: strings.Registration_code_could_not_be_found })
								break
							case EAddDeviceValidationType.AlreadyUsedRegistrationCode:
								this.setState({ activationCodeErrorText: strings.Registration_code_used_already })
								break
							case EAddDeviceValidationType.ApprovedIVRPhoneHasNotJob:
								this.setState({ errorJob: strings.select_a_job })
								break
						}
					})
			}
		})
	}

	validateForm() {
		let returnVal = true
		if (this.state.saveClicked && this.state.name.trim().length === 0) {
			this.setState({ nameErrorText: strings.Name_cannot_be_empty })
			returnVal = false
		} else {
			this.setState({ nameErrorText: "" })
		}

		if (this.state.saveClicked && this.state.enableIVR) {
			this.setState({ activationCodeErrorText: "" })
		}
		else {
			if (this.state.saveClicked && this.state.activationCode.length === 0) {
				this.setState({ activationCodeErrorText: strings.Registration_code_cannot_be_empty })
				returnVal = false
			} else if (!this.state.activationCode.match(activationCodeRegExp)) {
				this.setState({ activationCodeErrorText: strings.Invalid_registration_code_format })
				returnVal = false
			} else {
				this.setState({ activationCodeErrorText: "" })
			}
		}

		if (this.state.saveClicked && !this.state.isClockMode && !this.state.employeeForIndividual) {
			this.setState({ errEmployeeForIndividual: true })
			returnVal = false
		} else {
			this.setState({ errEmployeeForIndividual: false })
		}

		if (AppStateStore.allowAccontLevelClockDevice) {
			if (AccountStore.getJobsEnabled() && this.state.isClockMode && !this.state.hierarchyItemId && !this.state.jobId) {
				if (this.state.activeJobCount >= 100000) {
					this.setState({ errorAccountLevelClockModeMaxJobLimit: true, wariningAccountLevelClockMode: false })
					returnVal = false
				}
				else {
					this.setState({ errorAccountLevelClockModeMaxJobLimit: false, wariningAccountLevelClockMode: true })
				}
			}
			else {
				this.setState({ errorAccountLevelClockModeMaxJobLimit: false, wariningAccountLevelClockMode: false })
			}
		}
		else {
			if (this.state.saveClicked && this.state.isClockMode && !this.state.hierarchyItemId && !this.state.jobId) {
				this.setState({ errorHierarchyLevel: strings.Cannot_add_device_to_account_level })
				returnVal = false
			} else {
				this.setState({ errorHierarchyLevel: "" })
			}
		}

		if (this.checkIVRNumberAvailable() &&
			this.state.enableIVR &&
			!this.props.isJobDevice &&
			!this.state.jobId
		) {
			jobHelper.getAllowJobByHierarchy(this.state.hierarchyItemId) ?
				this.setState({ errorJob: strings.select_a_job }) :
				this.setState({ errorHierarchyLevel: strings.Job_is_not_allowed_for_this_hierarchy })
			returnVal = false
		}
		else {
			this.setState({ errorJob: "" })
		}

		if (this.state.errorApprovedIVRPhoneNumber) {
			returnVal = false
		}
		return returnVal
	}

	handleWarningAccountLevelClockMode(cb) {
		this.state.wariningAccountLevelClockMode ?
			AppStateStore.setConfirmDialogContent({
				title: strings.Warning,
				content: strings.Account_Level_Clock_Device_Warning_Msg,
				confirm: cb
			}) :
			cb()
	}

	checkIVRNumberAvailable() {
		return AccountStore.getIVREnabled() &&
			(
				this.props.isJobDevice ||
				(
					this.state.isClockMode && !this.state.isMobileClockMode &&
					!(this.props.isHierarchyDevice || this.props.employeeForIndividual)
				)
			)
	}

	checkAvailableJob() {
		return !this.state.enableIVR &&
			((this.state.isClockMode && !this.state.jobId) || !this.state.isClockMode)
	}

	render() {
		const readonly = this.props.editableDevice ? this.props.readonly : false
		const customFieldLabels = AccountStore.getCurrentAccountSettings() && AccountStore.getCurrentAccountSettings().CustomFieldSettings.DeviceCustomLabels
		return (
			<div>
				<Dialog
					open
					autoScrollBodyContent
					title={readonly ? strings.Device : this.props.editableDevice ? strings.Edit_Device : strings.Add_Device}
					actions={
						<div>
							{!this.props.editableDevice &&
								<FlatButton data-intercom-target={"menu-Devices-Btn-SaveAnotherDevice"} label={strings.Add_Another} primary style={{ float: "left" }} labelStyle={{ textDecoration: "underline" }} onTouchTap={() => this.handleWarningAccountLevelClockMode(this.handleRequestAddAnother)} />
							}
							<FlatButton data-intercom-target={"menu-Devices-Btn-CloseAddDeviceDialog"} label={readonly ? strings.Close : strings.CANCEL} secondary onTouchTap={this.handleRequestClose} />
							{!readonly &&
								<FlatButton data-intercom-target={"menu-Devices-Btn-SaveDevice"} label={this.props.editableDevice ? strings.Edit_Device : strings.Add_Device} primary onTouchTap={() => this.handleWarningAccountLevelClockMode(this.handleRequestSave)} />
							}
						</div>
					}
				>
					{!this.props.employeeForIndividual &&
						<div style={{ textAlign: "left", verticalAlign: "top", marginTop: 20 }}>
							<div style={{ display: "flex", justifyContent: "space-between" }}>
								{!this.props.editableDevice && !this.isHierarchyJobDevice &&
									<Toggle
										data-intercom-target={"menu-Devices-Toggle-ClockMode"}
										label={strings.Clock_Mode}
										onToggle={() =>
											this.setState({
												isClockMode: !this.state.isClockMode,
												isMobileClockMode: false,
												employeeForIndividual: null,
												errEmployeeForIndividual: false,
												enableLocationFraudPrevention: false,
												enableIVR: false,
											}, () => this.validateForm())
										}
										defaultToggled={this.state.isClockMode}
										style={{ width: 275 }}
										disabled={readonly}
									/>
								}
								{this.checkIVRNumberAvailable() && this.state.isClockMode &&
									<Toggle
										data-intercom-target={"menu-Devices-Toggle-EnableIVR"}
										label={"Enable IVR"}
										onToggle={(event, value) =>
											this.setState({
												enableIVR: value,
												limitJobs: false,
												availableJobs: [],
												disableException: false,
												activationCode: this.props.editableDevice ? this.props.editableDevice.RegistrationCode : "",
												errorApprovedIVRPhoneNumber: value && !this.state.approvedIVRPhoneNumber ? true : false
											}, () => this.validateForm())
										}
										defaultToggled={this.state.enableIVR}
										style={{ width: 275 }}
										disabled={readonly}
									/>
								}
							</div>
							{this.state.isClockMode ?
								<div style={{ marginTop: 10 }}>
									{!this.props.isJobDevice && !this.state.enableIVR &&
										<Toggle
											data-intercom-target={"menu-Devices-Toggle-MobileClockMode"}
											label={strings.MobileClockMode}
											onToggle={(e, value) => this.setState({ isMobileClockMode: value, jobId: value ? null : this.state.jobId, enableLocationFraudPrevention: false })}
											defaultToggled={this.state.isMobileClockMode}
											style={{ width: 275 }}
											disabled={readonly}
										/>
									}
									{!this.isHierarchyJobDevice &&
										<div style={{ display: "inline-block", verticalAlign: "top", position: "relative" }}>
											<ChooseHierarchyJobChip
												readonly={readonly}
												hideJob={this.state.isMobileClockMode}
												hierarchyChipLabel={strings.Home_Hierarchy}
												jobChipLabel={checkJobFieldAvailable('singular') ? `Home ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Home_Job}
												hierarchyItemId={this.state.hierarchyItemId}
												jobId={this.state.jobId}
												errorHierarchyChipText={this.state.errorHierarchyLevel}
												errorJobText={this.state.errorJob}
												handleSelectHierarchyJob={(hierarchyItemId, job) => {
													this.setState({
														hierarchyItemId,
														jobId: job ? job.Id : null,
														limitJobs: job ? false : this.state.limitJobs,
														availableJobs: (job || this.state.hierarchyItemId !== hierarchyItemId) ? [] : this.state.availableJobs
													}, () =>
														this.validateForm()
													)
												}}
												//if Clock device's hierarchy removed, we should open with global filter hierarchy.
												openWithGlobalFilerWhenSelectedHierarchyIsInvalid
											/>
											{this.state.errorAccountLevelClockModeMaxJobLimit &&
												<div style={{ color: red500, fontSize: 12 }}>{strings.Account_Level_Clock_Device_Job_Limit_Error_Msg}</div>
											}
										</div>
									}
								</div> :
								<div>
									<EmployeeChip
										errEmployee={this.state.errEmployeeForIndividual}
										setEmployee={employeeForIndividual => this.setState({ employeeForIndividual }, () => this.validateForm())}
										filterByLevel
										readonly={this.props.editableDevice !== null || readonly}
										selectedEmployee={this.state.employeeForIndividual}
									/>
								</div>
							}
						</div>
					}
					<div style={{ height: 60, display: "inline-block", verticalAlign: "top", width: "50%" }}>
						<TextField
							data-intercom-target={"menu-Devices-Entry-Name"}
							autoFocus={true}
							floatingLabelText={strings.Name}
							value={this.state.name}
							onChange={e => this.setState({ name: e.target.value }, () => this.validateForm())}
							onKeyUp={event => event.keyCode === 13 && this.handleRequestSave()}
							errorText={this.state.nameErrorText}
							style={{ width: "100%", marginRight: 20 }}
							maxLength="20"
							disabled={readonly}
						/>
					</div>
					<div style={{ height: 60, display: "inline-block", verticalAlign: "top", width: "50%" }}>
						{this.state.enableIVR ?
							<IVRNumberText
								data-intercom-target={"menu-Devices-Entry-IVR_Phone_Number"}
								style={{ width: "100%", marginLeft: 10 }}
								phoneNumber={this.state.approvedIVRPhoneNumber}
								handleChange={(phoneNumber, error) =>
									this.setState({ approvedIVRPhoneNumber: phoneNumber, errorApprovedIVRPhoneNumber: error })
								}
								disabled={readonly}
							/> :
							<TextField
								data-intercom-target={"menu-Devices-Entry-RegistrationCode"}
								floatingLabelText={strings.Registration_Code}
								value={this.state.activationCode}
								onChange={e => this.setState({ activationCode: e.target.value.toUpperCase() }, () => this.validateForm())}
								onKeyUp={event => event.keyCode === 13 && this.handleRequestSave()}
								errorText={this.state.activationCodeErrorText}
								style={{ width: "100%", marginLeft: 10 }}
								maxLength="20"
								disabled={this.props.editableDevice ? true : false}
							/>
						}
					</div>
					{!this.state.enableIVR &&
						<div style={{ display: "flex", marginTop: 35, justifyContent: "space-between" }}>
							<Toggle
								data-intercom-target={"menu-Devices-Toggle-EnableLocationException"}
								label={strings.EnableLocationException}
								onToggle={() => this.setState({ disableException: !this.state.disableException })}
								defaultToggled={!this.state.disableException}
								style={{ width: 250 }}
								disabled={readonly || this.state.enableIVR}
							/>
							{AccountStore.getAllowMobileLocationFraudPreventionOnDevice() &&
								(!this.state.isClockMode || this.state.isMobileClockMode) &&
								<Toggle
									data-intercom-target={"menu-Devices-Toggle-EnableMobileLocationFraudPrevention"}
									label={strings.Enable_Mobile_Location_Fraud_Prevention}
									onToggle={() => this.setState({ enableLocationFraudPrevention: !this.state.enableLocationFraudPrevention })}
									toggled={this.state.enableLocationFraudPrevention}
									style={{ width: 340 }}
									disabled={readonly}
								/>
							}
						</div>
					}
					{(this.state.isClockMode || this.state.isMobileClockMode) &&
						<div style={{ display: "flex", }}>
							<TextField
								data-intercom-target={"menu-Devices-Entry-DeviceAdminPin"}
								floatingLabelText={strings.Device_Admin_Pin}
								value={this.state.adminPin}
								onChange={e => this.setState({ adminPin: e.target.value.replace(/\D/g, "") })}
								style={{ width: "100%" }}
								maxLength="10"
								disabled={readonly}
							/>
							<TextField
								data-intercom-target={"menu-Devices-Entry-ExternalId"}
								floatingLabelText={strings.External_ID}
								value={this.state.externalId}
								onChange={e => this.setState({ externalId: e.target.value })}
								style={{ width: "100%", marginLeft: 10 }}
								disabled={readonly}
							/>
						</div>
					}
					{!this.props.isJobDevice && !this.state.enableIVR &&
						<div style={{ marginTop: 20 }}>
							<Toggle
								data-intercom-target={"menu-Devices-Toggle-LimitDeviceJobs"}
								label={checkJobFieldAvailable('plural') ? `Limit Device ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel}` : strings.Limit_Device_Jobs}
								onToggle={(e, value) => this.setState({ limitJobs: value, jobId: value ? null : this.state.jobId, availableJobs: value ? this.state.availableJobs : [] })}
								defaultToggled={this.state.limitJobs}
								style={{ width: 275 }}
								disabled={readonly || this.state.enableIVR}
							/>
							{this.state.limitJobs &&
								<div style={{ marginTop: 10 }}>
									<JobsChip
										label={checkJobFieldAvailable('plural') ? `Allowed ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel}` : strings.Allowed_Jobs}
										filterHierarchyId={this.state.hierarchyItemId}
										multiSelectable
										selectedJobs={this.state.availableJobs}
										restrictHierarchy={false}
										handleSave={availableJobs => this.setState({ availableJobs })}
									/>
								</div>
							}
						</div>
					}
					<TextField
						data-intercom-target={"menu-Devices-Entry-Note"}
						floatingLabelText={strings.Note}
						value={this.state.description}
						onChange={e => this.setState({ description: e.target.value })}
						style={{ width: "100%" }}
						disabled={readonly}
					/>
					<div style={{ display: "flex" }}>
						<TextField
							data-intercom-target={"menu-Devices-Entry-Field1"}
							floatingLabelText={customFieldLabels.Field1Label || `${strings.Custom_Field} 1`}
							value={this.state.field1}
							onChange={e => this.setState({ field1: e.target.value })}
							style={{ width: "50%" }}
							disabled={readonly}
						/>
						<TextField
							data-intercom-target={"menu-Devices-Entry-Field2"}
							floatingLabelText={customFieldLabels.Field2Label || `${strings.Custom_Field} 2`}
							value={this.state.field2}
							onChange={e => this.setState({ field2: e.target.value })}
							style={{ marginLeft: 10, width: "50%" }}
							disabled={readonly}
						/>
					</div>
					<div style={{ display: "flex" }}>
						<TextField
							data-intercom-target={"menu-Devices-Entry-Field3"}
							floatingLabelText={customFieldLabels.Field3Label || `${strings.Custom_Field} 3`}
							value={this.state.field3}
							onChange={e => this.setState({ field3: e.target.value })}
							style={{ width: "50%" }}
							disabled={readonly}
						/>
						<TextField
							data-intercom-target={"menu-Devices-Entry-Field4"}
							floatingLabelText={customFieldLabels.Field4Label || `${strings.Custom_Field} 4`}
							value={this.state.field4}
							onChange={e => this.setState({ field4: e.target.value })}
							style={{ marginLeft: 10, width: "50%" }}
							disabled={readonly}
						/>
					</div>
				</Dialog>
			</div>
		)
	}
}